import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import "./CaseQuestions.css";
import ResultModal from "../Components/ResultModal";

const CaseQuestions = () => {
  const { id } = useParams();
  /*   const [scenario, setScenario] = useState("");
  const [scenarioBn, setScenarioBn] = useState(""); */
  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showModal, setShowModal] = useState(false);
  const lang = localStorage.getItem("lang") || "en";
  const [score, setScore] = useState(0);

  useEffect(() => {
    const fetchQuestions = async () => {
      const jwtToken = localStorage.getItem("jwtToken");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/casequestions`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id }),
        }
      );
      const result = await response.json();
      if (!result.error) {
        /* setScenario(result.data.scenario);
        setScenarioBn(
          result.data.scenario_bangla || "দুঃখিত, কোনো বাংলা বিবরণ নেই।"
        ); */
        setQuestions(result.data.questions);
      }
    };
    fetchQuestions();
  }, [id]);
  const closeModal = () => {
    setShowModal(false);
    window.location.href = "/casestudy";
  };

  const handleOptionSelect = (qid, index) => {
    setAnswers({ ...answers, [qid]: index });
  };

  const handleSubmit = async () => {
    const jwtToken = localStorage.getItem("jwtToken");

    const payload = {
      case_id: id,
      answers,
    };

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/submit_case`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const result = await response.json();
    if (!result.error) {
      /* alert(
        lang === "bn"
          ? "সাবমিট করা হয়েছে! আপনার ফলাফল দেখুন।"
          : "Submitted! Check your results."
      ); */
      console.log(result);
      setScore(result.data.score * 3);
      setShowModal(true);
    } else {
      alert(
        (lang === "bn" ? "সাবমিশন ব্যর্থ: " : "Submission failed: ") +
          result.msg
      );
    }
    /* window.location.href = "/casestudy"; */
  };

  if (questions.length === 0)
    return <div>{lang === "bn" ? "লোড হচ্ছে..." : "Loading..."}</div>;

  const q = questions[current];

  const getText = (banglaText, englishText) => {
    if (lang === "bn") {
      return (
        <>
          <span style={{ fontFamily: "var(--ff-bangla)", display: "block" }}>
            {banglaText || "তথ্য অনুপলব্ধ"}
          </span>
          <span>{englishText}</span>
        </>
      );
    } else {
      return <>{englishText}</>;
    }
  };

  return (
    <div className="overview">
      <Sidebar />
      <div className="casequestions-container">
        <div className="question-box">
          <h2 className="question-text">
            {getText(q.question_text_bangla, q.question_text)}
          </h2>
          {q.image && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <video
                src={q.image}
                controls
                style={{ maxWidth: "60%", borderRadius: "10px" }}
              >
                {lang === "bn"
                  ? "আপনার ব্রাউজার ভিডিও প্লেব্যাক সমর্থন করে না।"
                  : "Your browser does not support the video tag."}
              </video>
            </div>
          )}
          <div className="options-grid">
            {[
              [q.option_1_bangla, q.option_1],
              [q.option_2_bangla, q.option_2],
              [q.option_3_bangla, q.option_3],
              [q.option_4_bangla, q.option_4],
            ].map(([bn, en], idx) => (
              <div
                key={idx}
                className={`option ${
                  answers[q.question_id] === idx ? "selected" : ""
                }`}
                onClick={() => handleOptionSelect(q.question_id, idx)}
                style={{
                  padding: "8px",
                  margin: "5px 0",
                  border: "1px solid #ccc",
                  cursor: "pointer",
                }}
              >
                {getText(bn, en)}
              </div>
            ))}
          </div>

          <div className="nav-buttons">
            <button
              onClick={() => setCurrent((prev) => Math.max(prev - 1, 0))}
              disabled={current === 0}
            >
              {lang === "bn" ? "পেছনে" : "Previous"}
            </button>
            <button
              onClick={() =>
                setCurrent((prev) => Math.min(prev + 1, questions.length - 1))
              }
              disabled={current === questions.length - 1}
            >
              {lang === "bn" ? "পরবর্তী" : "Next"}
            </button>
          </div>

          <div className="submit-section">
            <button onClick={handleSubmit}>
              {lang === "bn" ? "সব উত্তর সাবমিট করুন" : "Submit All Answers"}
            </button>
          </div>
        </div>
        {setShowModal && (
          <ResultModal
            showModal={showModal}
            onClose={closeModal}
            testType={lang === "bn" ? "কেস স্টাডি" : "Case Study"}
            score={score}
            fullMark={3}
            lang={lang}
          />
        )}
      </div>
    </div>
  );
};

export default CaseQuestions;
